import Icon from "lib/components/Icons"
import Text from "lib/components/Text"
import { useContext, useEffect } from "react"
import { LanguageContext } from "context/LanguageContext"

export default function BubbleChat({ setClose }) {
  const { useTranslation: t } = useContext(LanguageContext)

  const handleClose = () => {
    setClose(true)
    document.cookie = "bubbleChat=closed; path=/; max-age=86400; Secure; SameSite=Strict"
  }

  useEffect(() => {
    const handleClick = (e: Event) => {
      setClose(true)
    }

    const observer = new MutationObserver(() => {
      const btn = document.querySelector(".qcw-trigger-btn")
      if (btn) {
        btn.addEventListener("click", handleClick)
        observer.disconnect()
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })

    return () => {
      const btn = document.querySelector(".qcw-trigger-btn")
      if (btn) {
        btn.removeEventListener("click", handleClick)
      }
      observer.disconnect()
    }
  }, [])

  return (
    <div className="fixed right-20 mr-2 bottom-24 w-[280px] h-[81px] sm:w-[358px] sm:h-[96px] sm:right-20 sm:mr-2 lg:bottom-8 bg-info-surface p-3 rounded-2xl z-20">
      <div className="relative">
        <Text customClass="font-semibold text-[12px] sm:text-base">
          Halo👋🏻
        </Text>
        <Text customClass="font-semibold text-[12px] sm:text-base">
          Kami siap membantu konsultasi <br />produk & layanan sesuai kebutuhan Anda.
        </Text>
        <button
          type="button"
          aria-label={t("close") || "Close"}
          className="absolute right-0 top-0"
          onClick={handleClose}>
          <Icon iconName="close"/>
        </button>
      </div>
    </div>
  )
}